"use client"

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useMemo } from "react" // No need for useState

interface HeadTitleProps {
  title?: string // Defaults to 'Wallet Report'
  subtitle?: string // If undefined, derive from pathname; else use as-is (even if '')
  key?: any // Optional: Force re-mount on change (e.g., pass unique value from parent)
}

export function HeadTitle({
  title = "Nextjs 15",
  subtitle,
  key: forceKey, // Renamed to avoid React key conflict
}: HeadTitleProps) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  // Derive subtitle only if prop is undefined (not ''); otherwise use prop directly
  const derivedSubtitle = useMemo(() => {
    // If subtitle prop is provided (even empty string), use it—no derivation
    if (subtitle !== undefined) return subtitle

    // Fallback: Extract/format last path segment
    const lastSegment = pathname.split("/").pop() || ""
    return lastSegment
      .replace(/-/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase())
  }, [subtitle, pathname]) // Depend on pathname directly—no state needed

  useEffect(() => {
    const fullTitle = derivedSubtitle ? `${title} | ${derivedSubtitle}` : title
    document.title = fullTitle
    // Debug: console.log('Title updated:', fullTitle)  // Remove in prod
  }, [title, derivedSubtitle]) // Re-runs on prop or derived changes

  // If using forceKey, it triggers full re-mount (resets effects)
  // But prefer prop-driven updates over this
  return <></> // Or wrap in <React.Fragment key={forceKey}> if mounting needed
}
